import React, { Component } from 'react'



class PreparationTeamApplication extends Component {
    // 组件内部
    constructor(props) {
        super(props)
        this.state = {
            
        }

    }

    componentDidMount() {

    }

    // 页面渲染区
    render() {

        return (
            <div className="teamApplication" >
               
                这是筹备队申请
            </div>

        )
    }
}



export default PreparationTeamApplication



// WEBPACK FOOTER //
// ./src/routes/teamApplication/PreparationTeamApplication.jsx